"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var UpgradeButtonType;
(function (UpgradeButtonType) {
    UpgradeButtonType["Danger"] = "danger";
    UpgradeButtonType["Success"] = "success";
})(UpgradeButtonType || (UpgradeButtonType = {}));
var UpgradeButton = function (props) {
    var onClick = function () {
        props.telemetry.track("Upgrade Prompt Viewed", {
            upgrade_prompt_view_origin: props.origin,
        });
        props.initSubscription.init();
    };
    if (!props.trial.isOnTrial()) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "upgrade-button upgrade-button--".concat(getType(props.trial)), onClick: onClick }, props.children || "Upgrade"));
};
var getType = function (trial) {
    if (trial.hasTimeLimit() && trial.daysRemaining() <= 5) {
        return UpgradeButtonType.Danger;
    }
    else if (!trial.hasTimeLimit() && trial.hasProjectLimit() && trial.projectsRemaining() <= 3) {
        return UpgradeButtonType.Danger;
    }
    else {
        return UpgradeButtonType.Success;
    }
};
exports.default = UpgradeButton;
